import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = { class: "col-md-7" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row mb-2" }
const _hoisted_25 = { class: "col-md-9" }
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = { class: "col-md-9" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = { class: "col-md-9" }
const _hoisted_35 = { class: "row mb-2" }
const _hoisted_36 = { class: "col-md-9" }
const _hoisted_37 = { class: "row mb-2" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "row mb-2" }
const _hoisted_40 = { class: "col-md-9" }
const _hoisted_41 = { class: "row mb-2" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "row mb-2" }
const _hoisted_45 = { class: "col-md-9" }
const _hoisted_46 = { class: "row mb-2" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_50 = { class: "col-md-9" }
const _hoisted_51 = {
  key: 1,
  class: "row"
}
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "card-footer" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-2" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_59 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "col-md-2" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-12 fw-bold fs-6 mb-3" }
const _hoisted_64 = { class: "col-md-12 mb-2" }
const _hoisted_65 = { class: "col-md-12" }
const _hoisted_66 = { class: "col-md-12 mt-2" }
const _hoisted_67 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_68 = {
  key: 1,
  class: "alert alert-success"
}

import { onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesService";
import * as contratosService from "@/services/clientesContratosService";
import { useAcl } from "vue-simple-acl";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";
import Dependentes from "./ClientesDependentes.vue";
import Documentos from "./ClientesDocumentos.vue";
import Contratos from "./ClientesContratos.vue";
import Vouchers from "./ClientesVouchers.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

import { fdataHora, isoParaData } from "@/utils/funcoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {


//vue
const acl = useAcl();


//componentes
const route = useRoute();

var controle = reactive({

  model: {

  } as service.Cliente,
  tipos: ['Familiar', 'Empresarial'],
  simNao: [
    { texto: 'SIM', valor: true },
    { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],
  podeGravar: true,
  podeCartao: true,
  erro: "",
  status: "",

  janAlterarSenha: false,
  formSenha: {
    senhaNova: '',
    confirmaNovaSenha: '',
  },
})

onMounted(() => {

  console.log("buscar")
  if (route.params.id) {
    // Se houver um ID na rota, buscar os detalhes do usuário
    service.obterPorId(Number(route.params.id))
      .then(async r => {
        controle.model = r;
        await buscarContratos();
      })
      .catch(error => {
        controle.erro = `Erro ao carregar: ${error}`;
      });
  }

  setTimeout(() => {
    var el = document.getElementById("inputFocus");
    if (el) {
      el.focus();
    }
  }, 500);

});

async function buscarContratos() {
  try {
    controle.status = "Buscando contratos...";
    controle.erro = "";
    const contratos = await contratosService.obter({ clienteId: controle.model.clienteId } as contratosService.Filtros);

    var contratosSemAssinar = contratos.filter(c => c.dataAssinatura == null == null);

    if (acl.can('supervisor') || acl.can('admin')) {
      controle.podeGravar = true;
    }
    else {
      controle.podeGravar = acl.can('vendedor') && (contratosSemAssinar.length > 0);
    }

    if (acl.can('supervisor') || acl.can('admin')) {
      controle.podeCartao = (contratosSemAssinar.length == 0);
    }

    controle.status = "";
  } catch (error) {
    controle.erro = `Erro ao buscar contratos: ${error}`;
    controle.status = "";
  }
}

async function salvar() {
  try {
    // 1. Salvar o registro primeiro
    controle.status = "Salvando...";
    controle.erro = "";

    // if (controle.model.dataNascimento != null && controle.model.dataNascimento != "") {
    //   controle.model.dataNascimento = isoParaData(controle.model.dataNascimento);
    // }

    const resultado = await service.salvar(controle.model)
    
    controle.model = resultado;

    controle.status = "Salvo com sucesso!";
    setTimeout(() => {
      controle.status = "";
    }, 3000);
  } catch (error) {
    controle.erro = `Erro ao salvar: ${error}...`;
    return;
  }
}

async function cartao() {
  try {
    //abrir a pagina do cartao em outra aba
    const url = `/clientes/cartao/${controle.model.clienteId}`;
    window.open(url, '_blank');

  } catch (error) {
    controle.erro = `Erro ao abrir cartão: ${error}...`;
    return;
  }
}

function abrirAlterarSenha() {
  controle.formSenha.senhaNova = '';
  controle.formSenha.confirmaNovaSenha = '';
  controle.janAlterarSenha = true;
}

function confirmarAlterarSenha() {
  controle.status = "Alterando senha...";
  controle.erro = "";
  service.alterarSenha(
    controle.model.clienteId,
    controle.formSenha.senhaNova,
    controle.formSenha.confirmaNovaSenha
  )
    .then(() => {
      controle.status = "Senha alterada com sucesso!";
      setTimeout(() => {
        controle.janAlterarSenha = false;
        controle.status = "";
      }, 3000);
    })
    .catch(erro => {
      controle.erro = erro;
      controle.status = "";
    });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Cadastro de Clientes",
      items: [
    { label: 'Clientes', to: '/clientes' },
    { label: 'Cadastro', to: '/clientes/cadastro' }]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = '')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "clienteId",
                      class: "form-label"
                    }, "ID")
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.clienteId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.clienteId) = $event)),
                      id: "clienteId",
                      formato: 'Numero',
                      readonly: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "nome",
                      class: "form-label obrigatorio"
                    }, "Nome")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.nome,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.nome) = $event)),
                      id: "inputFocus",
                      formato: 'Maiusculo'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cpf",
                      class: "form-label"
                    }, "CPF")
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cpf,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.cpf) = $event)),
                      id: "cpf",
                      formato: 'CpfCnpj',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "rg",
                      class: "form-label"
                    }, "RG")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.rg,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.rg) = $event)),
                      id: "rg",
                      formato: 'Texto',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "rgExpedidor",
                      class: "form-label"
                    }, "RG Expedidor")
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.rgExpedidor,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.rgExpedidor) = $event)),
                      id: "rgExpedidor",
                      formato: 'Texto',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "telefone",
                      class: "form-label"
                    }, "Telefone")
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.telefone,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).model.telefone) = $event)),
                      id: "telefone",
                      formato: 'Telefone',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "celular",
                      class: "form-label"
                    }, "Celular")
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.celular,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).model.celular) = $event)),
                      id: "celular",
                      formato: 'Telefone',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "logradouro",
                      class: "form-label"
                    }, "Logradouro")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.logradouro,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.logradouro) = $event)),
                      id: "logradouro",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.numero,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(controle).model.numero) = $event)),
                      id: "numero",
                      formato: 'Maiusculo',
                      class: "",
                      placeholder: "Número"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "bairro",
                      class: "form-label"
                    }, "Bairro")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.bairro,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).model.bairro) = $event)),
                      id: "bairro",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cidadeId",
                      class: "form-label"
                    }, "Cidade")
                  ], -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(AutoCompleteCidade, {
                      modelValue: _unref(controle).model.cidadeId,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(controle).model.cidadeId) = $event)),
                      id: "cidadeId"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cep",
                      class: "form-label"
                    }, "CEP")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cep,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(controle).model.cep) = $event)),
                      id: "cep",
                      formato: 'Cep',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "complemento",
                      class: "form-label"
                    }, "Complemento")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.complemento,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(controle).model.complemento) = $event)),
                      id: "complemento",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "dataNascimento",
                      class: "form-label"
                    }, "Data Nascimento")
                  ], -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(TextBox, {
                      formato: 'Data',
                      modelValue: _unref(controle).model.dataNascimento,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).model.dataNascimento) = $event)),
                      id: "dataNascimento"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "email",
                      class: "form-label"
                    }, "Email")
                  ], -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.email,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).model.email) = $event)),
                      id: "email",
                      formato: 'email',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "nomeConjuge",
                      class: "form-label"
                    }, "Nome Cônjuge")
                  ], -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.nomeConjuge,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(controle).model.nomeConjuge) = $event)),
                      id: "nomeConjuge",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cpfConjuge",
                      class: "form-label"
                    }, "CPF Cônjuge")
                  ], -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cpfConjuge,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(controle).model.cpfConjuge) = $event)),
                      id: "cpfConjuge",
                      formato: 'CpfCnpj',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "observacoes",
                      class: "form-label"
                    }, "Observações")
                  ], -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.observacoes,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(controle).model.observacoes) = $event)),
                      id: "observacoes",
                      formato: 'Texto',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "ativo",
                      class: "form-label"
                    }, "Cortesia")
                  ], -1)),
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(controle).model.cortesia) = $event)),
                      id: "cortesia",
                      class: "form-select form-select-sm"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: String(tipo.valor),
                          value: tipo.valor
                        }, _toDisplayString(tipo.texto), 9, _hoisted_43))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(controle).model.cortesia]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "clienteIndicou",
                      class: "form-label"
                    }, "Cliente indicou")
                  ], -1)),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(AutoCompleteClientes, {
                      modelValue: _unref(controle).model.clienteIndicouId,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(controle).model.clienteIndicouId) = $event)),
                      id: "clienteIndicou"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "ativo",
                      class: "form-label"
                    }, "Ativo")
                  ], -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(controle).model.ativo) = $event)),
                      id: "ativo",
                      class: "form-select form-select-sm"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: String(tipo.valor),
                          value: tipo.valor
                        }, _toDisplayString(tipo.texto), 9, _hoisted_48))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(controle).model.ativo]
                    ])
                  ])
                ]),
                (_unref(controle).model.usuario)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "cadastradoPor",
                          class: "form-label"
                        }, "Cadastrado por")
                      ], -1)),
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.usuario.nomeCompleto,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(controle).model.usuario.nomeCompleto) = $event)),
                          id: "cadastradoPor",
                          formato: 'Texto',
                          class: "",
                          readonly: "readonly"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(controle).model.usuario)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "cadastradoPor",
                          class: "form-label"
                        }, "Dt Cadastro")
                      ], -1)),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("input", {
                          type: "text",
                          value: _unref(fdataHora)(_unref(controle).model.dataCadastro),
                          id: "dataCadastro",
                          class: "form-control form-control-sm",
                          readonly: "true"
                        }, null, 8, _hoisted_53)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                (_unref(controle).podeGravar)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (salvar()))
                    }, "Gravar"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_57, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                (_unref(controle).podeGravar)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn btn-sm btn-success me-2",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (cartao()))
                    }, "Imprimir Cartão"))
                  : _createCommentVNode("", true),
                (_unref(controle).model.clienteId)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "btn btn-sm btn-warning",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (abrirAlterarSenha()))
                    }, "Alterar Senha"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/clientes'
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(Contratos, {
      ClienteId: _unref(controle).model.clienteId
    }, null, 8, ["ClienteId"]),
    _createVNode(Dependentes, {
      ClienteId: _unref(controle).model.clienteId
    }, null, 8, ["ClienteId"]),
    _createVNode(Documentos, {
      ClienteId: _unref(controle).model.clienteId
    }, null, 8, ["ClienteId"]),
    _createVNode(Vouchers, {
      ClienteId: _unref(controle).model.clienteId
    }, null, 8, ["ClienteId"]),
    _createVNode(MsgBox, {
      id: 'janAlterarSenha',
      titulo: 'Alterar Senha',
      tamanho: 'modal-sm',
      exibir: _unref(controle).janAlterarSenha,
      onOnFechou: _cache[29] || (_cache[29] = ($event: any) => (_unref(controle).janAlterarSenha = false)),
      "botao-gravar": true,
      "botao-fechar": true,
      onOnGravar: _cache[30] || (_cache[30] = ($event: any) => (confirmarAlterarSenha()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(controle).model.nome), 1),
          _createElementVNode("div", _hoisted_64, [
            _cache[54] || (_cache[54] = _createElementVNode("label", null, "Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(controle).formSenha.senhaNova) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formSenha.senhaNova]
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _cache[55] || (_cache[55] = _createElementVNode("label", null, "Confirmar Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(controle).formSenha.confirmaNovaSenha) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formSenha.confirmaNovaSenha]
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            (_unref(controle).erro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_unref(controle).erro), 1))
              : _createCommentVNode("", true),
            (_unref(controle).status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_unref(controle).status), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})